export default __webpack_public_path__ + "static/media/logo.b920c1b1.svg";